var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3MHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_headgear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headgear_x5F_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M527.7,154.1c-1.2-17.9-32.5-18.2-46.3-19.2c-40.3-2.8-79.6,4.6-120.8,4.3c-28.9-0.2-59.6-3.2-91-5.9 l-3.7-0.5c-12.3-1.8-34.2,1.1-46.8,4.3c-14.7,3.7-35,14.5-23.9,33c7.1,11.9,30.7,26.3,43.1,31.4c16.6,6.8,29.4,11.2,46.8,15.3 c34.8,8.1,70.9,5,105.9,0.7c35.7-4.4,70.4-12,103.3-28.6C507,182.4,528.8,171.2,527.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M438.4,77.7c-9.5-4.8-21.5-7.5-31.2-11.7c-10-4.4-15.3-12.6-24.9-18.4c-20.8-12.4-50.9,2.8-68.7,14.8 c-22.7,15.3-37.9,5.1-53.2,24.5c-7.4,9.3-8.2,23.2-8.5,34.8c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C460.7,117.4,463.3,90.2,438.4,77.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M461.4,120.2c-0.9,0.4-1.7,0.8-2.6,1.2c-5.6,2.5-11.2,4.8-17,6.9c-56.8,19.4-120.7,18.4-176-4.5 c-4.7-2-9.3-4.1-13.8-6.3c-0.1,1.4-0.1,2.7-0.1,4.1c-0.2,7.1,0.4,18.7,1.2,29.2c1.4,0.9,2.7,1.8,4.1,2.6 c54.5,32.6,126.8,35.8,185.7,10.2c5.7-2.6,11.2-5.5,16.6-8.7c1.4-0.8,2.7-1.7,4.1-2.5c-0.2-4.4-0.4-8.4-0.6-11.2 C462.3,134.3,462.1,127.2,461.4,120.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M361.7,98.8c20.6-3.2,34.7-16.9,47-32.2c-0.5-0.2-1-0.4-1.4-0.6c-10-4.4-15.3-12.6-24.9-18.4 c-20.8-12.4-50.9,2.8-68.7,14.8c-3.9,2.7-7.7,4.6-11.2,6c1.2,2.2,2.5,4.3,4,6.3C318,92.4,340.4,102,361.7,98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M463.6,152.4c-0.2-4.4-0.4-8.4-0.6-11.2c-1.9-21-0.2-44.6-16.8-58.5c-5.7,25.7,0.7,51.9,3.7,77.5 c3.3-1.7,6.5-3.5,9.7-5.4C460.9,154.1,462.2,153.2,463.6,152.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M285,103.1c38.3,23.5,94.7,24.5,132-2.1c-12.8,25.5-53,28.9-78.6,26.8C316.1,125.6,302.1,119,285,103.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M329.3,140.2c-7.1,11.1-12.8,21-22.5,33.8c3.5,0.9,7.1,1.7,10.7,2.4c10.2-13.3,15.8-23.5,23.4-35.1 C336.9,141,333.1,140.7,329.3,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M376.2,141.4c-8.5,12.7-18.3,27.4-28.3,38.9c14.6,0.8,29.4,0.1,43.8-2.1c8.6-13,16.6-28.9,23.6-42.4 C402.5,138.7,389.4,140.6,376.2,141.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3MHair5);
export default __webpack_public_path__ + "static/media/m-hat3_m-hair5.3acc76f3e6177230ee8007b77e669f68.svg";
export { ForwardRef as ReactComponent };